import { FormulaCommand } from "./FormulaCommand";
import {
  calculateOperation,
  checkNumber,
} from "./operation/calculateOperation";

/**
 * Вычислить значение по формуле
 * @param cmdList Список команд, полученный из translateFormula
 * @param variables Значения переменных. uid => value
 * @throws В случае ошибок генерируются исключения
 */
export const calculateFormula = (
  cmdList: FormulaCommand[],
  variables: Record<string, number>,
): number => {
  const ctx: CalcCtx = { variables, stack: [] };
  cmdList.forEach((cmd) => execCmd(cmd, ctx));
  return checkNumber(ctx.stack[0], "Отсутствует результат");
};

type CalcCtx = {
  variables: Record<string, number>;
  stack: number[];
};

const execCmd = (cmd: FormulaCommand, ctx: CalcCtx): void => {
  // eslint-disable-next-line default-case
  switch (cmd.type) {
    case "number":
      ctx.stack.push(cmd.value);
      return;
    case "attr":
      ctx.stack.push(
        checkNumber(
          ctx.variables[cmd.uid],
          `Отсутствует значение переменной "${cmd.uid}"`,
        ),
      );
      return;
    case "op":
      calculateOperation[cmd.code]?.(ctx.stack);
  }
};
